<template>
  <div>
    <div v-if="isEdit && showMap" id="edit-current-zone" class="zone-list show">
      <div class="zone-cont" data-vv-scope="edit" onmouseover="">
        <div class="zone-name zone-common" style="height: 150px">

          <google-map id="map"
                      v-if="defaultMapOptions.center.lat"
                      ref="Map" class="h-full" :options="defaultMapOptions" :center.sync="defaultMapOptions.center">
            <google-map-marker
              :position.sync="location"
              :show.sync="showInfo"
              :icon="{url: require('@/assets/images/logo/pin.png'), scaledSize: {width: 32, height: 32}}"
            />

            <google-map-polygon
              v-if="shape"
              :key="'polygon'"
              :draggable="shape.draggable"
              :clickable="shape.clickable"
              :fill-color="shape.fillColor"
              :stroke-color="shape.strokeColor"
              :paths="shape.paths"
            ></google-map-polygon>

          </google-map>

        </div>
        <div class="zone-codes zone-common">

          <div class="zone-section-heading">Name</div>
          <input class="zone-input" v-model="name" type="text" placeholder="Small Charge" />

        </div>
        <div class="zone-time zone-common">
          <div class="zone-section-heading">Estimate Time</div>
          <input class="zone-input" v-model="estimatedTime" type="text" placeholder="65-70" />
        </div>
        <div class="zone-price zone-common">
          <div class="zone-section-heading">Delivery Fee</div>
          <input class="zone-input" v-model="price" type="text" placeholder="5" />
        </div>
        <div class="zone-edit ">
          <h3 @click="submitSave"><i class="fas fa-save"></i> Save</h3>
          <h3 @click="deleteBoundary"><i class="fas fa-trash-alt"></i> Delete</h3>
          <h3 class="zone-cancel" @click="clearData"><i class="fas fa-ban"></i> Cancel</h3>
        </div>
      </div>
    </div>
    <div v-else-if="boundary && shape && showMap" class="zone-cont">
      <div class="zone-name zone-common" style="height: 150px">
        <div ref="result"></div>
        <google-map id="map"
                    ref="Map" class="h-full" :options="defaultMapOptions"
                    :center.sync="location">
          <google-map-marker
            :position.sync="location"
            :show.sync="showInfo"
            :icon="{url: require('@/assets/images/logo/pin.png'), scaledSize: {width: 32, height: 32}}"
          />

          <google-map-polygon
            v-if="shape"
            ref="polygon"
            :key="'polygon'"
            :draggable="shape.draggable"
            :clickable="shape.clickable"
            :fill-color="shape.fillColor"
            :stroke-color="shape.strokeColor"
            :paths="polygon_paths"
          ></google-map-polygon>

        </google-map>

      </div>
      <div class="zone-codes zone-common">
        <div class="zone-section-heading">Name</div>
        <h4>{{ boundary.name }}</h4>
      </div>
      <div class="zone-time zone-common">
        <div class="zone-section-heading">Estimate Time</div>
        <h4>{{ boundary.estimatedTime ? boundary.estimatedTime : 'Not set' }}</h4>
      </div>
      <div class="zone-price zone-common">
        <div class="zone-section-heading">Delivery Fee</div>
        <h4>${{ boundary.price }}</h4>
      </div>
      <div class="zone-edit">
        <h3><i class="fas fa-edit"></i> Edit</h3>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    deleted: {
      type: Function
    },
    boundaryData: {
      type: Object,
      required: true
    },
    location: {
      type: Object
    },
    restaurantId: Number
  },
  computed: {
    polygon_paths () {
      const result_arr = JSON.parse(JSON.stringify(this.shape.paths))
      const first_index = 0
      result_arr.push(result_arr[first_index])
      return result_arr
    }
  },
  name: 'BoundaryItem',
  watch: {
    boundaryData () {
      this.showMap = false
      this.getBoundaryInfo()
    }
  },
  data () {
    return {
      isEdit: false,
      name: '',
      zone: '',
      color: '',
      price: 0,
      id: 0,
      restaurant_id: 0,
      estimatedTime: '',
      areas: [],
      zipCodes: [],
      boundary: null,
      showInfo: false,
      showMap: false,
      shape: null,
      defaultMapOptions: {
        center: {
          lat: this.location.lat,
          lng: this.location.lng
        },
        disableDefaultUI: true,
        scaleControl: false,
        scrollwheel: false,
        zoom: 11,
        title: 'Delivery Location',
        description: '',
        gestureHandling: 'greedy',
        zoomControl: false,
        mapTypeControl: false,
        styles: [
          {
            featureType: 'poi',
            stylers: [{ visibility: 'off' }]}
        ]
      }
    }
  },
  methods: {
    openConfirm (accept, cancel) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirm',
        clickNotClose: true,
        text: 'Are you sure you want to delete this item?',
        accept,
        cancel
      })
    },
    shadeColor (color, percent) {
      let R = parseInt(color.substring(1, 3), 16)
      let G = parseInt(color.substring(3, 5), 16)
      let B = parseInt(color.substring(5, 7), 16)

      R = parseInt(R * (100 + percent) / 100)
      G = parseInt(G * (100 + percent) / 100)
      B = parseInt(B * (100 + percent) / 100)

      R = (R < 255) ? R : 255
      G = (G < 255) ? G : 255
      B = (B < 255) ? B : 255

      const RR = ((R.toString(16).length === 1) ? `0${R.toString(16)}` : R.toString(16))
      const GG = ((G.toString(16).length === 1) ? `0${G.toString(16)}` : G.toString(16))
      const BB = ((B.toString(16).length === 1) ? `0${B.toString(16)}` : B.toString(16))

      return `#${RR}${GG}${BB}`
    },
    submitSave () {
      this.$vs.loading()
      this.$validator.validateAll('edit').then(result => {
        if (result) {
          const obj = {
            boundaryId: this.boundary.id,
            restaurantId: this.restaurantId,
            boundaryName: this.name,
            price: this.price,
            estimatedTime: this.estimatedTime,
            color: this.boundaryData.color
          }

          this.$store.dispatch('api/setBoundary', obj)
            .then(() => {
              this.getBoundaryInfo()
              this.$vs.loading.close()

              this.openAlert('Item saved successfully')
            })
            .catch(err => {
              console.error(err)
              this.$vs.loading.close()
            })

        }
      })
    },
    setData () {
      const { id, name, price, zipCodes, estimatedTime, geometry, color } = this.boundary
      this.clearData()
      this.id = id
      this.name = name
      this.price = price
      this.areas = geometry.coordinates[0][0]
      this.zipCodes = zipCodes
      this.estimatedTime = estimatedTime

      const paths = []
      this.areas.map(area => {
        const lat = parseFloat(area[1])
        const lng = parseFloat(area[0])

        const path = {
          lat,
          lng
        }
        paths.push(path)
      })

      this.shape = {
        fillColor: color,
        strokeColor: this.shadeColor(color, 20),
        draggable: false,
        clickable: true,
        paths
      }

      setTimeout(() => {
        this.showMap = true
      }, 500)
      //this.fitBounds()
    },
    fitBounds () {
      const bounds = new window.google.maps.LatLngBounds()
      this.shape.paths.map(path => {
        bounds.extend(path)

      })
      this.$refs.Map.fitBounds(this.$refs.polygon.getBounds())
    },
    getBoundaryInfo () {

      const boundary_info = {
        boundaryId: this.boundaryData.id,
        restaurantId: this.boundaryData.restaurant_id
      }

      this.$store.dispatch('api/getBoundary', boundary_info)
        .then(response => {
          this.boundary = response.data.data
          this.boundary.color = this.boundaryData.color
          this.setData()
        })
        .catch(err => {
          console.error(err)
        })
    },
    clearData () {
      this.isEdit = false
    },
    editData () {
      this.isEdit = true
    },
    addZone () {
      this.$validator.validateAll('zone').then(result => {
        if (result) {
          const obj = {
            boundaryId: this.id,
            restaurantId: this.restaurantId,
            zipCode: this.zone
          }

          this.$store.dispatch('api/setBoundaryZipcode', obj)
            .then(() => {
              this.getBoundaryInfo()
              this.openAlert('Item saved successfully')
            })
            .catch(err => {
              console.error(err)
            })

        }
      })
    },
    openAlert (text) {
      this.$vs.dialog({
        type:'alert',
        color: 'success',
        clickNotClose: true,
        title: 'Confirm',
        acceptText: 'Ok',
        text
      })
    },
    deleteZone (id) {
      this.openConfirm(() => {
        this.$vs.loading()
        const obj = {
          boundaryId: this.boundaryData.id,
          restaurantId: this.boundaryData.restaurant_id,
          zipCodeId: id
        }
        this.$store.dispatch('api/removeZipcodeBoundary', obj)
          .then(() => {
            this.getBoundaryInfo()
            this.$vs.loading.close()
          })
          .catch(err => {
            console.error(err)
            this.$vs.loading.close()
          })
      }, () => {})
    },
    deleteBoundary () {
      this.openConfirm(() => {
        this.$vs.loading()
        const obj = {
          boundaryId: this.boundaryData.id,
          restaurantId: this.boundaryData.restaurant_id
        }
        this.$store.dispatch('api/removeBoundary', obj)
          .then(() => {
            this.deleted()
            this.$vs.loading.close()
          })
          .catch(err => {
            console.error(err)
            this.$vs.loading.close()
          })
      }, () => {})
    }
  },

  mounted () {
    this.getBoundaryInfo()
  }
}
</script>

<style lang="scss">

</style>
